import React from 'react'

import Hero from '../hero/hero'
import SlicesWrapper from '../slices/slicesWrapper'
import PushContent from '../pushContent'

const NewsLayout = ({data, currentUrl, allNews}) => {
  // get further content
  let furtherContent = []
  const isCurrentNews = (element) => element.contentful_id === data.contentful_id
  const currentNewsIndex = allNews.findIndex(isCurrentNews)

  if (currentNewsIndex !== 0 && currentNewsIndex < allNews.length - 2) {
    furtherContent.push(allNews[currentNewsIndex - 1], allNews[currentNewsIndex + 1], allNews[currentNewsIndex + 2])
  } else if (currentNewsIndex === 0) {
    furtherContent.push(allNews[currentNewsIndex + 1], allNews[currentNewsIndex + 2], allNews[currentNewsIndex + 3])
  } else if (currentNewsIndex === allNews.length - 1) {
    furtherContent.push(allNews[currentNewsIndex - 1], allNews[currentNewsIndex - 2], allNews[currentNewsIndex - 3])
  } else {
    furtherContent.push(allNews[currentNewsIndex - 1], allNews[currentNewsIndex - 2], allNews[currentNewsIndex + 1])
  }

  furtherContent = furtherContent.filter(item => item !== undefined)

  return (
    <>
      <Hero 
        currentUrl={currentUrl}
        data={data}
        isNewsroom={true}
        type="news" />

      <div>
        <SlicesWrapper slices={data.slices} />
      </div>

      { (data.pushPages !== null || furtherContent.length > 0) &&
        <PushContent data={data.pushPages} autoItems={furtherContent} type="news" />
      }
    </>
  )
}

export default NewsLayout;